<template>
  <div class="client_logo" id="client_logo">
    <a :href="client.Website" target="_blank" :style="'background-image: url('+logoLight+')'"></a>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  computed: {
    ...mapState(["client"]),
    ...mapGetters(["logoDark", "logoLight"])
  }
};
</script>

<style>
</style>